import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'

import classes from './MiniCard.module.scss'

/** @type {import("./types").default} */
const MiniCard = ({ category, className, showCategoryLeader, href, stacked, ...props }) => {
  const eventContext = useEventContext({
    engagementComponent: 'category_minicard',
    engagementDestination: 'go-to_category_all-products',
    name: 'engagement_product_click',
  })
  const isMultiline = category.total_listings || (showCategoryLeader && category.category_leaders)
  return (
    <Button
      {...eventContext.addEvent({
        engagementDetails: 'category-card',
      })}
      {...props}
      className={clsx('MiniCard', classes.root, className, {
        [classes.stacked]: stacked,
      })}
      href={href || category.cta_urls?.detail}
    >
      {!isMultiline && <Icon size={40} prefix="ga" icon="category" className={classes.icon} />}
      <div className={classes.content}>
        <div
          className={clsx(classes.title, {
            [classes.multiline]: isMultiline,
          })}
        >
          {category.name}
        </div>
        {category.total_listings && (
          <div className={classes.apps}>
            <Icon size={16} prefix="far" icon="folder" className={clsx(classes.icon, classes.multiline)} />
            {category.total_listings} apps
          </div>
        )}
        {showCategoryLeader && category.category_leaders && (
          <div className={classes.apps}>
            <Icon
              className={clsx(classes.icon, classes.multiline, classes.gem)}
              size={16}
              prefix="ga"
              icon="category-leaders-gem"
            />
            {category.category_leaders.total_score}/100
          </div>
        )}
      </div>
    </Button>
  )
}

export default MiniCard
